import { isValidPhoneNumber } from "react-phone-number-input";

/** E.164-style: must include country code (+), no leading 0 after +. */
const E164_WITH_COUNTRY_CODE = /^\+[1-9]\d{6,14}$/;

/**
 * Returns true when the value is a present, country-coded, libphonenumber-valid number.
 */
export const isValidPhoneWithCountryCode = (value) => {
  if (!value || typeof value !== "string") {
    return false;
  }
  const trimmed = value.trim();
  if (!E164_WITH_COUNTRY_CODE.test(trimmed)) {
    return false;
  }
  return isValidPhoneNumber(trimmed);
};
